<template>
  <v-container>
    <v-form>
      <v-row>
        <v-col md="4">
          <v-text-field
            v-model="familyName"
            label="姓"
            type="text"
            data-vv-name="familyName"
            data-vv-as="名前"
            required
            :error-messages="errors.collect('familyName')"
          >
          </v-text-field>
        </v-col>
        <v-col md="4">
          <v-text-field
            v-model="personalName"
            label="名"
            type="text"
            v-validate="'required'"
            data-vv-name="personalName"
            data-vv-as="名前"
            required
            :error-messages="errors.collect('personalName')"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4">
          <v-text-field
            v-model="flatFamilyName"
            label="セイ"
            type="text"
            v-validate="'required'"
            data-vv-name="flatFamilyName"
            data-vv-as="名前"
            required
            :error-messages="errors.collect('flatFamilyName')"
          >
          </v-text-field>
        </v-col>
        <v-col md="4">
          <v-text-field
            v-model="flatPersonalName"
            label="メイ"
            type="text"
            v-validate="'required'"
            data-vv-name="familyName"
            data-vv-as="名前"
            required
            :error-messages="errors.collect('familyName')"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-col>
        <v-radio-group
          v-model="sex"
          row
          required
          v-validate="'required'"
          data-vv-name="sex"
          data-vv-as="性別"
          :error-messages="errors.collect('sex')"
        >
          <v-radio
            label="男性"
            value="male"
          >
          </v-radio>
          <v-radio
            label="女性"
            value="female"
          >
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col md="4">
        <v-text-field
          v-model="phone"
          label="電話番号"
          type="text"
          required
          v-validate="'required'"
          data-vv-name="phone"
          data-vv-as="電話番号"
          :error-messages="errors.collect('phone')"
        >
        </v-text-field>
      </v-col>
      <v-col md="4">
        <v-row>
          <v-col md="12">
            <v-text-field
              v-model="postalCode"
              label="郵便番号(ハイフンなし７ケタ)"
              type="text"
              required
              v-validate="'required'"
              data-vv-name="postalCode"
              data-vv-as="郵便番号"
              :error-messages="errors.collect('postalCode')"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-btn
              depressed
              rounded
              outlined
              color="primary"
              @click="searchAddress">
              住所検索
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6">
            <v-text-field
              v-model="prefecture"
              label="都道府県"
              type="text"
              v-validate="'required'"
              data-vv-name="prefecture"
              data-vv-as="都道府県"
              required
              :error-messages="errors.collect('prefecture')"
              >
            </v-text-field>
          </v-col>
          <v-col md="6">
            <v-text-field
              v-model="municipality"
              label="市区町村"
              type="text"
              v-validate="'required'"
              data-vv-name="municipality"
              data-vv-as="市区町村"
              required
              :error-messages="errors.collect('municipality')"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12">
            <v-text-field
              v-model="subAddress"
              label="下位住所（丁目番地以下）"
              type="text"
              required
              v-validate="'required'"
              data-vv-name="subAddress"
              data-vv-as="住所"
              :error-messages="errors.collect('subAddress')"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="4">
        <BirthdayPicker v-model="birthday"/>
        <v-autocomplete
          v-model="university"
          :items="universities"
          label="大学"
          item-text="name"
          required
          v-validate="'required'"
          data-vv-name="university"
          data-vv-as="大学名"
          :error-messages="errors.collect('university')"
        >
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-radio-group
          v-model="inUniversity"
          row
          required
          v-validate="'required'"
          data-vv-name="inUniversity"
          :error-messages="errors.collect('inUniversity')"
        >
          <v-radio
            label="在学"
            :value="true">
          </v-radio>
          <v-radio
            label="既卒"
            :value="false">
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col>
        <v-col class="font-weight-bold">
          指導希望時間帯
        </v-col>
        <div
          v-for="(availableSchedule, index) in availableSchedules.get()"
          :key="index"
        >
          <ScheduleEditor
            v-model="availableSchedules.get()[index]"
            :items="availableSchedules"
            @addNewLine="addNewLine"
            @deleteLine="deleteLine(availableSchedule)"/>
        </div>
      </v-col>
      <v-col md="4">
        <v-autocomplete
          v-model="expectedWage"
          :items="wages"
          label="(1時間あたり)希望報酬額(円)"
          item-text="name"
          required
          v-validate="'required'"
          data-vv-name="wages"
          data-vv-as="希望時給"
          :error-messages="errors.collect('wages')"
        >
        </v-autocomplete>
      </v-col>
      <v-col md="4">
        <v-text-field
          v-model="nearestStation"
          label="最寄り駅"
          type="text"
          required
          v-validate="'required'"
          data-vv-name="nearestStation"
          data-vv-as="最寄り駅"
          :error-messages="errors.collect('nearestStation')"
        >
        </v-text-field>
      </v-col>
      <v-col>
        <v-textarea
          v-model="selfIntroduction"
          label="自己紹介"
          type="text"
          required
          v-validate="'required'"
          data-vv-name="selfIntroduction"
          data-vv-as="自己紹介"
          :error-messages="errors.collect('selfIntroduction')"
        >
        </v-textarea>
      </v-col>
      <v-row
        class="ma-2"
        justify="end">
        <v-btn
          @click="update"
          rounded
          outlined
        >保存
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { universities } from '@/models/University.js'
import ScheduleEditor from '@/components/molecules/ScheduleEditor.vue'
import BirthdayPicker from '@/components/molecules/BirthdayPicker.vue'


export default {
  name: 'TeacherProfileEdit',
  components:{
    ScheduleEditor: ScheduleEditor,
    BirthdayPicker: BirthdayPicker
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      birthdayMenu: false,
      universities: universities,
    }
  },
  props: {
    value: Object,
  },
  methods: {
    update() {
      const result = this.$validator.validateAll()
      if (result) {
        this.$emit("update")
      } 
    },
    addNewLine(schedule) {
      // console.log("schedule:" + this.value.availableSchedules)
      this.$emit("addNewLine")
    },
    updateValue: function (diff) {
      this.$emit("input", { ...this.value, ...diff })
    },
    deleteLine(schedule) {
      this.$emit("deleteLine", schedule)
    },
    searchAddress() {
      this.$emit('searchAddress')
    }
  },
  computed: {
    wages() {
      var range = new Array()
      for (let i = 3; i <= 20; i++) {
        range.push(i*500)
      }
      return range
    },
    name: {
      get() {
        return this.value.name
      },
      set(name) {
        this.updateValue({ name })
      }
    },
    personalName: {
      get () {
        return this.value.name.personalName
      },
      set (personalName) {
        this.name = { ...this.name, personalName }
      }
    },
    familyName: {
      get () {
        return this.value.name.familyName
      },
      set (familyName) {
        this.name = { ...this.name, familyName }
      }
    },
    flatPersonalName: {
      get () {
        return this.value.name.flatPersonalName
      },
      set (flatPersonalName) {
        this.name = { ...this.name, flatPersonalName }
      }
    },
    flatFamilyName: {
      get () {
        return this.value.name.flatFamilyName
      },
      set (flatFamilyName) {
        this.name = { ...this.name, flatFamilyName }
      }
    },
    sex: {
      get() {
        return this.value.sex
      },
      set (sex) {
        this.updateValue({ sex })
      }
    },
    phone: {
      get() {
        return this.value.phone
      },
      set (phone) {
        this.updateValue({ phone })
      }
    },
    address: {
      get() {
        return this.value.address
      },
      set(address) {
        this.updateValue({ address })
      }
    },
    postalCode: {
      get () {
        return this.address.postalCode
      },
      set (postalCode) {
        this.address = { ...this.address, postalCode }
      }
    },
    prefecture: {
      get () {
        return this.value.address.prefecture
      },
      set (prefecture) {
        this.address = { ...this.address, prefecture }
      }
    },
    municipality: {
      get () {
        return this.address.municipality
      },
      set (municipality) {
        this.address = { ...this.address, municipality }
      }
    },
    subAddress: {
      get () {
        return this.address.subAddress
      },
      set (subAddress) {
        this.address = { ...this.address, subAddress }
      }
    },
    birthday: {
      get() {
        return this.value.birthday
      },
      set (birthday) {
        this.updateValue({ birthday })
      }
    },
    university: {
      get() {
        return this.value.university
      },
      set (university) {
        this.updateValue({ university })
      }
    },
    inUniversity: {
      get() {
        return this.value.inUniversity
      },
      set (inUniversity) {
        this.updateValue({ inUniversity })
      }
    },
    availableSchedules:{
      get () {
        return this.value.availableSchedules
      },
      set (availableSchedules) {
        this.updateValue({ availableSchedules })
      }
    },
    expectedWage:{
      get () {
        return this.value.expectedWage
      },
      set (expectedWage) {
        this.updateValue({ expectedWage })
      }
    },
    nearestStation: {
      get () {
        return this.value.nearestStation
      },
      set (nearestStation) {
        this.updateValue({ nearestStation })
      }
    },
    selfIntroduction:{
      get () {
        return this.value.selfIntroduction
      },
      set (selfIntroduction) {
        this.updateValue({ selfIntroduction })
      }
    },
  },
}
</script>
